module.exports = __webpack_public_path__ + "img/sparkle.453cece0.svg";